import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

import './Success.scss';
import img from '../../assets/images/success.png';

class Success extends Component {
    constructor() {
        super();

        this.state = {
            modal: true
        }

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className="metronic-font">
                <ModalBody className="text-center">
                    <img src={img} alt="success" height="140" />
                    <h3 className="mb-3">Успешно!</h3>

                    <div className="row">
                        <div className="col-12">
                            <Button color="success" className="mx-1" onClick={this.toggle}>Продолжть</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default Success;